import Swal from 'sweetalert2';

export const appAlert = Swal.mixin({ customClass: { popup: 'ot-alert' } });

// The one error box for people, instead of alert(): says what failed and what to do, never API internals.
export function showError(text: string, title = 'No se pudo completar') {
  return Swal.fire({ icon: 'error', title, text, customClass: { popup: 'ot-alert' }, confirmButtonText: 'Entendido' });
}

export async function confirmAction(title: string, text: string, action: string): Promise<boolean> {
  const result = await Swal.fire({
    icon: 'warning', title, text, showCancelButton: true, focusCancel: true,
    reverseButtons: true, confirmButtonText: action, cancelButtonText: 'Volver',
    customClass: { popup: 'ot-alert' }
  });
  return result.isConfirmed;
}
